import './calculation-product-tnved-cell.scss'

import cx from 'classnames'
import {
  Typography,
} from '@mui/material'

import {
  formatHSCode,
} from 'utils/helpers'

const CalculationProductTnvedCell = ({
  displayCode,
  originalCode,
}: {
  displayCode: string
  originalCode?: string | null
}) => {
  const formattedAfter = formatHSCode(displayCode) || '—'
  const original = originalCode?.trim() || ''
  const showBefore = Boolean(original)

  if (!showBefore) {
    return (
      <Typography component='span' variant='inherit'>
        {formattedAfter}
      </Typography>
    )
  }

  const formattedBefore = formatHSCode(original) || '—'
  const afterClassName = cx(
    'calculation-product-tnved-cell__after',
    'calculation-product-tnved-cell__after_changed',
  )

  return (
    <div className='calculation-product-tnved-cell'>
      <Typography
        component='span'
        variant='inherit'
        className='calculation-product-tnved-cell__before'
      >
        {formattedBefore}
      </Typography>
      <Typography
        component='span'
        variant='inherit'
        className={afterClassName}
      >
        {formattedAfter}
      </Typography>
    </div>
  )
}

export default CalculationProductTnvedCell
